import IndustryFinancialServicesView from 'views/Industry/FinancialServicesPage'

const FinancialServices = () => <IndustryFinancialServicesView />

export default FinancialServices
